import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Checkbox, Divider, FormControlLabel, Popover, Stack } from '@mui/material';
import Iconify from 'src/components/Iconify';
import TableActionButton from 'src/components/TableActionButton';

const ColumnVisibilityMenu = ({
  columns,
  isVisible,
  getLabel,
  isDisabled,
  onChange,
  onReset,
  minWidth = 240,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = useCallback(event => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <TableActionButton
        variant="outlined"
        onClick={handleOpen}
        startIcon={<Iconify icon="mdi:table-column-remove" width={18} height={18} />}
        sx={{ px: 1.25 }}>
        Columns
      </TableActionButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
        <Box sx={{ p: 2, minWidth }}>
          <Stack spacing={1}>
            {columns.map(column => (
              <FormControlLabel
                key={column.key}
                control={
                  <Checkbox
                    checked={isVisible(column)}
                    disabled={isDisabled(column)}
                    onChange={event => onChange(column.key, event.target.checked)}
                  />
                }
                label={getLabel(column)}
                sx={{ my: -0.25 }}
              />
            ))}
          </Stack>
          {onReset ? (
            <>
              <Divider sx={{ mt: 1.5, mb: 1 }} />
              <Button
                size="small"
                onClick={onReset}
                sx={{ textTransform: 'none', fontSize: 12, py: 0.25, px: 0.75 }}>
                Reset to default
              </Button>
            </>
          ) : null}
        </Box>
      </Popover>
    </>
  );
};

ColumnVisibilityMenu.propTypes = {
  columns: PropTypes.array.isRequired,
  isVisible: PropTypes.func,
  getLabel: PropTypes.func,
  isDisabled: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func,
  minWidth: PropTypes.number,
};

ColumnVisibilityMenu.defaultProps = {
  isVisible: column => !column.hidden,
  getLabel: column => column.label || column.key,
  isDisabled: column => !!column.required,
};

export default ColumnVisibilityMenu;
